import styled from 'styled-components/macro';

export const Container = styled.div`
  position: relative;
`;

export const OptionList = styled.div`
  position: absolute;
  z-index: 1;
  left: 0;
  width: 100%;
  margin-top: -0.1rem;
  padding: 0.5rem 0;
  background: ${({ theme }) => theme.color.white};
  border: 0.063rem solid ${({ theme }) => theme.color.gray[200]};
  border-radius: 0 0 0.188rem 0.188rem;
`;

export const Option = styled.div`
  padding: 0.35rem 0.75rem;

  &:hover {
    background: ${({ theme }) => theme.color.gray[100]};
  }
`;
